export const SESSION_TOKEN = "sessionToken";
export const ACCESS_TOKEN = "accessToken";
export const USER_ROLE = "userRole";
export const REMEMBER_ME = "remember_me";

export const setToken = (token: string) => sessionStorage.setItem(SESSION_TOKEN, token);
export const getToken = () => sessionStorage.getItem(SESSION_TOKEN) ?? "";
export const removeToken = () => sessionStorage.removeItem(SESSION_TOKEN);

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN) ?? "";
export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN);
export const setAccessToken = (accessToken: string) => localStorage.setItem(ACCESS_TOKEN, accessToken);
export const setRole = (role: string) => localStorage.setItem(USER_ROLE, role);
export const getRole = () => localStorage.getItem(USER_ROLE) ?? "";

export const OPTIMISE_ROUTES_ACCESS = "canAccessOptimiseRoutes";
export const setOptimiseRoutesAccess = (value: boolean) =>
  localStorage.setItem(OPTIMISE_ROUTES_ACCESS, String(value));
export const getOptimiseRoutesAccess = () =>
  localStorage.getItem(OPTIMISE_ROUTES_ACCESS) === "true";

export const setRememberMe = (email: string, remember = true) =>
  localStorage.setItem(REMEMBER_ME, JSON.stringify({ email, remember }));

export const getRememberMe = (): { email: string; remember: boolean } | null => {
  const raw = localStorage.getItem(REMEMBER_ME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed?.email !== "string") return null;
    const remember = Boolean(parsed?.remember);
    // Sanitize legacy payloads that contained password by rewriting without it.
    if (parsed?.password) {
      setRememberMe(parsed.email, remember);
    }
    return { email: parsed.email, remember };
  } catch {
    return null;
  }
};

export const removeRememberMe = () => localStorage.removeItem(REMEMBER_ME);
